import { useQuery } from '@tanstack/react-query'

import { useAuth } from '@/hooks/use-auth'
import { GetGruposDeUnidadesDeNegocioDisponiveisService } from '@/http/grupo-unidades-de-negocio.service'
import type { TGruposDeUnidadesDeNegocioDisponiveisResponse } from '@/types/unidade-negocio'
import { UMA_HORA } from '@/utils/constants'
import { regionaisKeys } from '@/utils/regionais-query-keys'

export const useAcessoASimulacaoRapida = () => {
  const { user } = useAuth()

  const { data, isPending } = useQuery<TGruposDeUnidadesDeNegocioDisponiveisResponse>({
    queryKey: regionaisKeys.listas(),
    queryFn: () => new GetGruposDeUnidadesDeNegocioDisponiveisService().execute().then((response) => response.data),
    staleTime: UMA_HORA,
  })

  const cidadeAtiva = data?.gruposDisponiveis.find((grupo) => grupo.id === user?.grupoDeUnidadesDeNegocioId)

  return {
    permiteAcesso: Boolean(cidadeAtiva?.permiteAcessoASimulacaoRapida),
    acessoCarregando: isPending,
  }
}
